import { useIsAtBottom } from "../thread/threadViewportState";
import { FadeGradient } from "./FadeGradient";

export const ComposerFadeGradient = () => {
  const isAtBottom = useIsAtBottom();

  return <FadeGradient isVisible={!isAtBottom} />;
};
